module.exports = __webpack_public_path__ + "img/switzerland-stomach-cancer-male.5fb433ad.png";